import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function BarcodeIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 54.94 41.83"
      style={{ width: `55px`, height: `42px`, color: RoutalPalette.secondary40, ...props.style }}
    >
      <g>
        <path d="M7.68,35.68V6.16H9.06V35.68Zm2.06,0V6.16h.7v29.5Zm2.09,0V6.16h.68v29.5Zm3.45,0V6.16H16v29.5Zm2.76,0V6.16h1.37v29.5Zm3.45,0V6.16h.69v29.5Zm1.39,0V6.16h.68v29.5Zm1.38,0V6.16h.68v29.5Zm2.75,0V6.16h1.38v29.5Zm3.44,0V6.16h1.39v29.5Zm2.77,0V6.16h1.39v29.5Zm2.77,0V6.16h1.39v29.5Zm2.07,0V6.16h1.38v29.5Zm3.47,0V6.16h2.06v29.5Zm2.75,0V6.16H45v29.5Zm1.38,0V6.16H47V35.68Z" />
        <path d="M2.21,33.38H.2v8.23H8.42v-2H2.21Z" />
        <path d="M52.71,39.6H46.5v2h8.22V33.38h-2Z" />
        <path d="M2.21,2.25H8.42v-2H.2V8.46h2Z" />
        <path d="M52.71,8.46h2V.23H46.5v2h6.21Z" />
      </g>
    </SvgIcon>
  );
}
